import StoreReview from "./StoreReview";
export default StoreReview;
